import { Star } from "lucide-react";

export const EaseStars = ({ stars, showLabel = false, lightMode = false }) => (
  <div className="flex flex-col items-start">
    <div className="flex gap-0.5">
      {[1, 2, 3, 4, 5].map((i) => (
        <Star key={i} className={`w-3.5 h-3.5 ${i <= stars ? "fill-amber-400 text-amber-400" : lightMode ? "text-white/30" : "text-slate-200"}`} />
      ))}
    </div>
    {showLabel && <span className={`text-xs mt-0.5 ${lightMode ? "text-white/80" : "text-slate-400"}`}>Ease of claim</span>}
  </div>
);
